import { Action, Dispatch, bindActionCreators } from 'redux';
import { PartnerCreateOrEdit, StateProps, DispatchProps } from '../components/on-site-manager/PartnerCreateOrEdit';
import { createPartner, createPartnerAddress, editPartner, editPartnerAddress, fetchPartners } from '../redux/on-site-manager/partners/actions';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';

import { connect } from 'react-redux';
import { sendOnsiteEmail } from '../redux/on-site-manager/on-sites/actions';
import { toast } from '../redux/message/actions';

export function mapStateToProps(): StateProps {
  return {};
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        onPageDidMount,
        onPageWillUnmount,
        fetchPartners,
        createPartner,
        editPartner,
        editPartnerAddress,
        createPartnerAddress,
        sendOnsiteEmail,
        toast,
      },
      dispatch
    ),
  };
}

export const OnSiteManagerPartnerCreateContainer = connect(mapStateToProps, mapDispatchToProps)(PartnerCreateOrEdit);
